export default "The current user is: {{ currentUser }}.\nTodays date is: {{ today }}.\nThe current project is: {{ currentProject }}."